//utils
import { setLocalStorageFlag, getPercentGainCellRenderAttrs } from "../../../../utils/common";
import { 
  getCellTemplateWithTooltip, tViews 
} from "../../../../utils/table";
import { textChangeColors } from "../../../../utils/colors";
import { routeURLs } from "../../../../utils/enums";
export const getTableColumns = (
  tableId,
  store,  
  openTableSettings,
  navigate
) => {
  const handlePathDetailsNavigation = (evt, props) => {
    evt.preventDefault();
    if (props && props.model) {
      const pathDetailsList = props.model;
      const pathDetails = {
        pathQosPair: pathDetailsList.pathQosPair,
        localDevice: pathDetailsList.localDevice,
        remoteDevice: pathDetailsList.remoteDevice,
        defaultQuality: pathDetailsList.defaultQuality,
        recommendationQuality: pathDetailsList.recommendationQuality,
        totalNumUsers: pathDetailsList.totalNumUsers,
        impactedUsers: pathDetailsList.impactedUsers,
        gains: pathDetailsList.gains
      };
      setLocalStorageFlag("pathDetails", JSON.stringify(pathDetails));
      navigate(routeURLs.appInfoPathMetric);
    }
  };

  const tableColumns = [
    {
      prop: "localSite",
      get name() { return tViews('appGroupPerSite.localSiteLabel')},
      sortable: true,
      size: 200
    },
    {
      prop: "localDevice",
      get name() { return tViews('appGroupPerSite.localDeviceLabel')},
      sortable: true,
      size: 180,
    },
    {
      prop: "remoteSite",
      get name() { return tViews('appGroupPerSite.remoteSiteLabel')},
      sortable: true,
      size: 200,
    },
    {
      prop: "remoteDevice",
      get name() { return tViews('appGroupPerSite.remoteDeviceLabel')},
      sortable: true,
      size: 180,
      cellTemplate: (...args) => getCellTemplateWithTooltip(tableId, ...args)
    },
    {
      prop: "location",
      get name() { return tViews('predictiveNetworks.appTableConfigLocationLabel')},
      sortable: true,
      size: 200,
      cellTemplate: (...args) => getCellTemplateWithTooltip(tableId, ...args)
    },
    {
      prop: "defaultQuality",
      get name() { return tViews('predictiveNetworks.heroBarCurPath')},
      size: 220,
      headerAlign: "right",
      cellTemplate: (createElement, props) => {
        const { style } = getPercentGainCellRenderAttrs(props);

        return createElement("div", {
          innerHTML: props?.model?.defaultQuality,
          style: {
            ...style,
            textAlign: "right"
          }
        });
      }
    },
    {
      prop: "recommendationQuality",
      get name() { return tViews('predictiveNetworks.heroBarRecomPath') },
      size: 220,
      headerAlign: "right",
      cellTemplate: (createElement, props) => {
        const { style } = getPercentGainCellRenderAttrs(props);

        return createElement("div", {
          innerHTML: props?.model?.recommendationQuality,
          style: {
            ...style,
            textAlign: "right"
          }
        });
      }
    },
    {
      prop: "gains",
      get name() { return tViews('appGroupPerSite.recoExpecteGainLabel') },
      sortable: true,
      size: 140,
      headerAlign: "right",
      cellTemplate: (createElement, props) => {
        const { innerHTML, style } = getPercentGainCellRenderAttrs(props, textChangeColors.positive, textChangeColors.negative);

        return createElement("div", {
          id: "table-col-row-site-impact-col",
          innerHTML,
          style: {
            ...style,
            textAlign: "right"
          }
        });
      }
    },
    {
      prop: "impactedUsers",
      get name() { return tViews('appGroupPerSite.recoImpactedUsers') },
      sortable: true,
      size: 150,
      headerAlign: "right",
      cellProperties: () => {
        return {
          style: {
            textAlign: "right",
          },
        }
      },
    },
    {
      prop: "action",
      get name() { return tViews('reporTableActions')},
      sortable: true,
      size: 260,
      cellTemplate: (createElement, props) => {
        const content = createElement("div", {
          innerHTML: `
          <hbr-link class="application-trending-apps-qoe-widget-link" id="app-trend-app-qoe-${props.model.idTable}" tabindex="0">${tViews('appGroupPerSite.pathListTable')}</hbr-link>`,
          onClick: (evt) => handlePathDetailsNavigation(evt, props),
          onKeydown: (evt) => {
            if (evt.key === "Enter" || evt.key === " ") {
              handlePathDetailsNavigation(evt, props);
            }
          }
        });
        return content;
      },
    },
    {
      prop: "actions",
      get name() { return tViews('reporTableActions')},
      get hiddenText() { return tViews('reporTableActions')},
      disableToggle: true,
      sortable: false,
      headerSlot: false,
      pin: "colPinEnd",
      size: 70,
      columnTemplate: (createElement) => {
        return createElement("hbr-icon-button", {
          name: "gear-six-outlined",
          class: "hbr-css__table-cell-align-center gear-icon",
          aria: { label: tViews('tableSettings') },
          "data-testid": "setting-path-device-table",
          onClick: (evt) => {
            evt.stopPropagation();
            openTableSettings();
          }
        });
      }
    }
  ];

  return tableColumns.map((item) => {
    let obj = {
      ...item,
      id: item.prop
    }
    return obj;
  });
};

/**
 * Returns list of objects that has data for each row in the all sites table
 * @description creates a new object with source and destinaions endpoints
 * @param {object} sitesObject list of sites object
 * @return {array} list of objects that has data for each row in the all sites table
 */
export const getAllSitesColumns = () => {
  //sitesObject
  return [
    {
      data: "siteIds",
      get title() { return tViews('appGroupPerSite.recoSiteLabel')},
      render: data => {
        return `<div>${data}</div>`;
      }
    },
    {
      data: "location",
      get title() { return tViews('appGroupPerSite.recoPathLocationLabel')},
      render: data => {
        return data;
      }
    },
    {
      data: "currentPath",
      get title() { return tViews('predictiveNetworks.appTableConfigCurPathLabel')},

      render: data => {
        if (data) return data.replaceAll(",", ", ");
        else return "--";
      }
    },
    {
      data: "recommendedPath",
      get title() { return tViews('predictiveNetworks.appTableConfigRecomPathLabel')},

      render: data => {
        if (data) return data.replaceAll(",", ", ");
        else return "--";
      }
    },
    {
      data: "defaultQuality",
      get title() { return tViews('defaultPathQualtyLabel')},
      render: data => {
        return data;
      }
    },
    {
      data: "recommendationQuality",
      get title() { return tViews('recoPathQualityLabel')},
      render: data => {
        return data;
      }
    },
    {
      data: "gains",
      get title() { return tViews('appGroupPerSite.recoExpecteGainLabel')},
      render: data => {
        if (!data) return "--";
        else
          return `<div id="table-col-row-site-impact-col">
                  ${data}%
                <div>`;
      }
    },
    {
      data: "impactedUsers",
      get title() { return tViews('appGroupPerSite.recoImpactedUsers')},
      render: data => {
        return data;
      }
    },
    {
      data: "state",
      get title() { return tViews('appGroupPerSite.recoActionLabel')},
      render: data => {
        return data;
      }
    }
  ];
};
export const getTools = (isEndpointTableLabel = false) => {
  const tool = [
    // Builtin title ref
    {
      ref: {
        name: "title",
        config: {
          text: isEndpointTableLabel
            ? tViews('singleSitePathTableLabel')
            : tViews('allSiteSitesLabel'),
          count: false
        }
      }
    },
    {
      ref: {
        name: "search"
      }
    }
  ];
  return tool;
};
